export default {
  en: {
    title: 'Reset Password | Activate you account',
    description: 'Enter a new password for your account and do click in active account. | Request new a link for active your account.',
    button: 'Change Password | Active Account',
    password: 'New password',
    repeat: 'Repeat the new password',
    email: 'Email',
    request_token: 'Request a new link',
    agreement: {
      accept: 'I accept the',
      terms: 'terms and conditions',
      use: 'for use of Videsk.',
    },
    errors: {
      password: 'Please enter a password with minimum of 6 characters',
      repeat: 'The passwords not match.',
      email: 'Please enter you email for request a new link.',
      agreement: 'For activate account you need accept terms and conditions.',
    },
    notifications: {
      url: {
        title: 'Invalid URL',
        description: 'The URL is invalid, please check the email your receive is from us or date, maybe is older.',
      },
      token: {
        title: 'Invalid Link',
        description: 'The link has expired or is invalid, please check or request a new one.',
      },
      passwordPolicy: {
        title: 'Password Policy',
        description: 'The password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
      }
    },
    success: 'The password was changed, you can login now.',
    fail: 'Something went wrong, please try again.',
    request_notification: {
      success: 'The link was requested, please check your email.',
      fail: {
        accountActivated: 'The account is activated, please login.',
        tooManyRequest: 'You request too much links, please try in 24 hrs.',
        unknown: 'The server having a bad day, try again.',
      },
    },
  },
  es: {
    title: 'Restablecer Contraseña | Active su cuenta',
    description: 'Ingrese una nueva contraseña y luego haga clic en activar cuenta. | Solicite un nuevo enlace para activar su cuenta.',
    button: 'Cambiar contraseña | Activar Cuenta',
    password: 'Nueva contraseña',
    repeat: 'Repita la nueva contraseña',
    email: 'Correo electrónico',
    request_token: 'Solicitar un nuevo enlace',
    agreement: {
      accept: 'Acepto los',
      terms: 'términos y condiciones',
      use: 'para poder usar Videsk.',
    },
    errors: {
      password: 'Ingrese una contraseña de mínimo 6 caracteres.',
      repeat: 'Las contraseñas no coinciden.',
      email: 'Ingrese su correo electrónico para solicitar un nuevo enlace.',
      agreement: 'Para activar la cuenta, debe aceptar los términos y condiciones.',
    },
    notifications: {
      url: {
        title: 'URL inválida',
        description: 'La URL no es válida, verifique que el correo electrónico que recibió es nuestro y la fecha, tal vez sea anterior.',
      },
      token: {
        title: 'Enlace inválido',
        description: 'El enlace a expirado o es inválido, verifique o solicite uno nuevo.',
      },
      passwordPolicy: {
        title: 'Política de Contraseña',
        description: 'La contraseña debe tener al menos 8 caracteres y contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial.',
      }
    },
    success: 'La contraseña ha sido cambiada, ingrese a su cuenta.',
    fail: 'Algo salió mal, inténtelo de nuevo.',
    request_notification: {
      success: 'Se ha enviado un nuevo enlace, revise su correo electrónico.',
      fail: {
        accountActivated: 'La cuenta está activada, inicie sesión.',
        tooManyRequest: 'Haz solicitado demasiados enlaces, inténtalo en 24 horas.',
        unknown: 'El servidor tiene un mal día, intente nuevamente.',
      },
    },
  },
  fr: {
    title: 'Réinitialiser le mot de passe | Activer votre compte',
    description: 'Entrez un nouveau mot de passe pour votre compte et cliquez sur activer le compte. | Demandez un nouveau lien pour activer votre compte.',
    button: 'Changer le mot de passe | Activer le compte',
    password: 'Nouveau mot de passe',
    repeat: 'Répétez le nouveau mot de passe',
    email: 'Email',
    request_token: 'Demander un nouveau lien',
    agreement: {
      accept: 'J\'accepte les',
      terms: 'conditions d\'utilisation',
      use: 'pour l\'utilisation de Videsk.',
    },
    errors: {
      password: 'Veuillez entrer un mot de passe d\'au moins 6 caractères',
      repeat: 'Les mots de passe ne correspondent pas.',
      email: 'Veuillez entrer votre email pour demander un nouveau lien.',
      agreement: 'Pour activer le compte, vous devez accepter les termes et conditions.',
    },
    notifications: {
      url: {
        title: 'URL invalide',
        description: 'L\'URL est invalide, veuillez vérifier si l\'email que vous avez reçu est bien de nous ou s\'il est ancien.',
      },
      token: {
        title: 'Lien invalide',
        description: 'Le lien a expiré ou est invalide, veuillez vérifier ou demander un nouveau.',
      },
      passwordPolicy: {
        title: 'Politique de mot de passe',
        description: 'Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial.',
      }
    },
    success: 'Le mot de passe a été modifié, vous pouvez vous connecter maintenant.',
    fail: 'Quelque chose s\'est mal passé, veuillez réessayer.',
    request_notification: {
      success: 'Le lien a été demandé, veuillez vérifier votre email.',
      fail: {
        accountActivated: 'Le compte est activé, veuillez vous connecter.',
        tooManyRequest: 'Vous avez demandé trop de liens, veuillez réessayer dans 24 heures.',
        unknown: 'Le serveur rencontre des problèmes, veuillez réessayer.',
      },
    },
}

};
